<template>
    <i v-if="loading" class="far fa-spinner"></i>
    <div v-else-if="list.length > 0" class="tw-grid tw-grid-cols-2">
        <div v-for="item in list" :key="item.id">
            <!-- uncomment this when completely vue -->
            <!-- <router-link :to="{name: 'groups.show' params: {group_slug: item.slug}}" class="tw-flex tw-mb-4 tw-items-center tw-cursor-pointer"> -->
            <a class="tw-flex tw-mb-4 tw-items-center tw-cursor-pointer" :href="`/groups/${item.slug}`">
                <img class="tw-rounded-full tw-w-12 tw-h-12 tw-mr-4" :src="item.image" :alt="item.name" onerror="this.src='/img/avatar.png'" />
                <p class="secondary-c tw-font-bold">{{ item.name }}</p>
            </a>
            <!-- </router-link> -->
        </div>
    </div>
    <p v-else class="tw-text-gray-400">{{ $t('groups.no_group_user') }}</p>
</template>

<script>
export default {
    name: 'GroupList',
    props: ['profile'],
    data() {
        return {
            list: [],
            loading: true,
        }
    },

    methods: {
        getGroups() {
            this.loading = true;
            axios.get(`/api/v3/users/${this.profile.id}/groups`).then((response) => {
                this.list = response.data.data;
                this.loading = false;
            });
        },
    },
    mounted() {
        this.getGroups();
    }
}
</script>